import { IMembers } from '@pages/members/constants';
import { centricClientCheck } from '@utils/helpers';
import create, { SetState, StateCreator, StoreApi } from 'zustand'

interface IMemberListStore {
  filtersData: any,
  filtersDataHandler: (x:any) => void
  tempFiltersData: any,
  tempFiltersDataHandler: (x:any) => void
  reminderStartFilter : any,
  setReminderStartFilter : (x:any) => void
  reminderEndFilter : any,
  setReminderEndFilter : (x:any) => void
  adtState : any,
  setADTState : (x:any) => void
  selectedMemberType : any,
  memberTypeHandler : (x:any) => void
  rowsPerPage : number,
  setRowsPerPage : (x:any) => void
  sortBy : any,
  setSortByFilter : (x:any) => void
  sortType : undefined,
  setSortTypeFilter : (x:any) => void
  searchBy : undefined,
  setSearchBy : (x:any) => void
  searchKeyword : undefined,
  setSearchKeyword : (x:any) => void,
  memberListRegistryDropDown : any,
  setMemberListRegistryDropDown : (x: any) => void,
  defaultAdmitAndDischargeStartDate : any,
  setDefaultAdmitAndDischargeStartDate : (x:any) => void
  defaultAdmitAndDischargeEndDate : any,
  setDefaultAdmitAndDischargeEndDate : (x:any) => void
  patientIdList: [],
  setPatientIdList: (x : any) => void,
  data:IMembers[],
  setMemberListData : (x : any) => void,
  caseLoadLoader: boolean,
  setCaseLoadLoader : (x : any) => void,
  columnSearchInfo : any,
  setColumnSearchInfo : (x:any) => void,  
  filteredInfo : any,
  setFilteredInfo : (x:any) => void,
  searchByPage : any,
  setSearchByPage : (x:any) => void,
  clearStore: () => void,
  totalPages : any,
  setTotalPages :(x:any) => void,
  searchKeywordNew : any,
  setSearchKeywordNew :(x:any) => void,
  isResetLayoutEnable: boolean,
  setIsResetLayoutEnable :(x:boolean) => void,
  showFilters : boolean;
  setShowFilters : (x:any) => void,
  registryDependentMemberListPageStore : any,
  setRegistryDependentMemberListPageStore : (x:any) => void,
  ADTPatientIdList : any,
  setADTPatientIdList : (x : any) => void,
  outReachesData : any,
  setOutReachesData : (x : any) => void,
  alertPage : number;
  setAlertPage : (x:any) => void,
  reminderToBeDeleted : any;
  setReminderToBeDeleted : (x:any) => void,
  holidayList : any;
  setHolidayList : (x:any) => void,
  notesData : any,
  setNotesData : (x : any) => void,
}

let store:
  | StateCreator<IMemberListStore, [], [], IMemberListStore>
  | StoreApi<IMemberListStore> = (set: SetState<IMemberListStore>) => ({
  filtersData: [],
  filtersDataHandler: (x) => {
    set((state) => ({ filtersData: x }));
  },
  searchKeywordNew: [],
  setSearchKeywordNew: (x) => {
    set((state) => ({ searchKeywordNew: x }));
  },
  tempFiltersData: [],
  tempFiltersDataHandler: (x) => {
    set((state) => ({ tempFiltersData: x }));
  },
  reminderStartFilter: undefined,
  setReminderStartFilter: (x) => {
    set((state) => ({ reminderStartFilter: x }));
  },
  reminderEndFilter: undefined,
  setReminderEndFilter: (x) => {
    set((state) => ({ reminderEndFilter: x }));
  },
  adtState: "",
  setADTState: (x) => {
    set((state) => ({ adtState: x }));
  },
  selectedMemberType: null,
  memberTypeHandler: (x) => {
    set((state) => ({ selectedMemberType: x }));
  },
  rowsPerPage:  centricClientCheck() ? 10 : 5,
  setRowsPerPage: (x) => {
    set((state) => ({ rowsPerPage: x }));
  },
  sortBy: undefined,
  setSortByFilter: (x) => {
    set((state) => ({ sortBy: x }));
  },
  sortType: undefined,
  setSortTypeFilter: (x) => {
    set((state) => ({ sortType: x }));
  },
  searchBy: undefined,
  setSearchBy: (x) => {
    set((state) => ({ searchBy: x }));
  },
  searchKeyword: undefined,
  setSearchKeyword: (x) => {
    set((state) => ({ searchKeyword: x }));
  },
  memberListRegistryDropDown : [],
  setMemberListRegistryDropDown: (x) => {
    set((state) => ({ memberListRegistryDropDown: x }));
  },
  defaultAdmitAndDischargeStartDate: "",
  setDefaultAdmitAndDischargeStartDate: (x) => {
    set((state) => ({ defaultAdmitAndDischargeStartDate: x }));
  },
  defaultAdmitAndDischargeEndDate: "",
  setDefaultAdmitAndDischargeEndDate: (x) => {
    set((state) => ({ defaultAdmitAndDischargeEndDate: x }));
  },
  patientIdList: [],
  setPatientIdList: (x) => {
    set((state) => ({ patientIdList: x }));
  },
  data : [],
  setMemberListData :(x) => {
    set((state) => ({ data: x }));
  },
  caseLoadLoader: false,
  setCaseLoadLoader : (x) => {
    set((state) => ({ caseLoadLoader: x }));
  },

  ADTPatientIdList : {},
  setADTPatientIdList :(x) => {
    set((state) => ({ ADTPatientIdList: x }));
  },

  searchByPage : 1,
  setSearchByPage :(x) => {
    set((state) => ({ searchByPage: x }));
  },
  totalPages : 0,
  setTotalPages :(x) => {
    set((state) => ({ totalPages: x }));
  },
  columnSearchInfo: {},
  setColumnSearchInfo: (x) => {
    set((state) => ({ columnSearchInfo: x }));
  },
  filteredInfo : {},
  setFilteredInfo :  (x) => {
    set((state) => ({ filteredInfo: x }));
  }, 
  isResetLayoutEnable: false,
  setIsResetLayoutEnable: (x) => {
    set((state) => ({ isResetLayoutEnable: x }));
  },
  showFilters: false,
  setShowFilters : (x) => {
    set((state) => ({ showFilters: x }));
  },
  registryDependentMemberListPageStore: {},
  setRegistryDependentMemberListPageStore : (x) => {
    set((state) => ({ registryDependentMemberListPageStore: x }));
  },
  outReachesData : {},
  setOutReachesData : (x : any) => {
    set((state) => ({ outReachesData: x }));
  },
  alertPage : 1,
  setAlertPage : (x) => {
  set((state) => ({ alertPage: x }));
  },
  reminderToBeDeleted : null,
  setReminderToBeDeleted : (x) => {
  set((state) => ({ reminderToBeDeleted: x }))
  },
  holidayList : [],
  setHolidayList : (x) => {
    set((state) => ({ holidayList: x }));
  },
  notesData : null,
  setNotesData : (x : any) => {
    set(() => ({ notesData: x }));
  },
  clearStore: () => {
    set(() => ({ filtersData: [] }));
    set(() => ({ tempFiltersData: [] }));
    set(() => ({ reminderStartFilter: undefined }));
    set(() => ({ reminderEndFilter: undefined }));
    set(() => ({ adtState: "" }));
    set(() => ({ selectedMemberType: null }));
    set(() => ({ rowsPerPage:  centricClientCheck() ? 10 : 5 }));
    set(() => ({ sortBy: undefined }));
    set(() => ({ sortType: undefined }));
    set(() => ({ searchBy: undefined }));
    set(() => ({ searchKeyword: undefined }));
    set(() => ({ defaultAdmitAndDischargeStartDate: undefined }));
    set(() => ({ defaultAdmitAndDischargeEndDate: undefined }));
    set(() => ({ patientIdList: [] }));
    set(() => ({ data : [] }));
    set(() => ({ ADTPatientIdList : {} }));
    set(() => ({ columnSearchInfo : {} }));
    set(() => ({ filteredInfo : {} }));
    set(() => ({ searchByPage : 1 }));
    set(() => ({ totalPages : 0 }));
    set(() => ({ showFilters : false }));
    set(() => ({ searchKeywordNew : [] }));
    set(() => ({ caseLoadLoader : false }));
    set(() => ({ isResetLayoutEnable : false }));
    set(() => ({ registryDependentMemberListPageStore : {} }));
    set(() => ({ alertPage : 1 }));
    set(() => ({ outReachesData : {} }));
    set(() => ({ reminderToBeDeleted : null }));
    set(() => ({ holidayList : [] }));
    set(() => ({ notesData : null }));
  },
});


export const useMemberListStore  = create(store)